import { render, staticRenderFns } from "./testTask.vue?vue&type=template&id=a4f88104&"
import script from "./testTask.vue?vue&type=script&lang=js&"
export * from "./testTask.vue?vue&type=script&lang=js&"
import style0 from "./testTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports